import { render } from "./invite-and-assign-access.vue?vue&type=template&id=057d63b2"
import script from "./invite-and-assign-access.vue?vue&type=script&setup=true&lang=js"
export * from "./invite-and-assign-access.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/create-catalog/components/invite-and-assign-access.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057d63b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057d63b2', __exports__)) {
    console.log('reload')
    api.reload('057d63b2', __exports__)
  }
  
  module.hot.accept("./invite-and-assign-access.vue?vue&type=template&id=057d63b2", () => {
    console.log('re-render')
    api.rerender('057d63b2', render)
  })

}


export default __exports__